const payment = {
    price: 'Price',
    totalPrice: 'Total Price',
    pricePerPerson: 'per person',
    // Payment Buttons
    bookTrip: 'Book "{tripName}"',
    deposit: 'Deposit: (to be paid now)',
    balance: 'Balance: (to be paid one month before the trip)',
    payDeposit: 'Pay Deposit (€{amount})',
    payBalance: 'Pay Balance (€{amount})',
    // Simple labels without placeholders
    depositLabel: 'Deposit',
    balanceLabel: 'Balance',
    processing: 'Processing...',
    securityInfo: {
        title: 'Security Information',
        stripeSecure: '• Payments are securely handled by Stripe',
        noCardStorage: '• We do not store your card data',
        balanceDue: '• The balance must be paid one month before the trip',
        emailConfirmation: '• You will receive a confirmation email after each payment'
    },
    tripFullMessage: 'The trip is full. It is not possible to make the deposit payment.',
    tripFull: 'Trip Full',
    cannotPayTripFull: 'Cannot pay, the trip is already full',

    // Payment Success
    paymentSuccess: 'Payment completed successfully!',
    trip: 'Trip',
    paymentType: 'Payment Type',
    amount: 'Amount',
    nextStep: 'Next step: The balance must be paid one month before the trip. You will receive a notification when it\'s time to complete the payment.',
    viewTrip: 'View Trip',
    viewBookings: 'View my bookings',
    close: 'Close',

    // User Bookings
    yourBookings: 'Your Bookings',
    loadingBookings: 'Loading bookings...',
    noBookings: 'You don\'t have any bookings yet',
    noBookingsMessage: 'You have not yet made any bookings.',
    bookingError: 'Error loading bookings',
    retry: 'Retry',
    tripDate: 'Trip date',
    bookedOn: 'Booked on',
    toBeConfirmed: 'To be confirmed',
    paymentStatus: 'Payment Status',
    total: 'Total',
    depositPaid: 'Paid',
    balancePaid: 'Paid',
    depositPending: 'Pending',
    balancePending: 'Pending',
    depositToPayNow: '(to be paid now)',
    balanceToPayBeforeTrip: '(to be paid one month before the trip)',
    depositFailed: 'Failed',
    balanceFailed: 'Failed',
    confirmed: 'Confirmed',
    pending: 'Pending',
    cancelled: 'Cancelled',

    // Payment Return
    verifyingPayment: 'Verifying payment...',
    paymentVerificationError: 'Error verifying payment',
    paymentCancelled: 'Payment cancelled',
    verifying: 'Verifying payment...',
    missingSessionId: 'Missing session ID. Payment not valid.',
    paymentCompleted: 'Payment Completed!',
    paymentSuccessMessage: 'Your payment has been processed successfully. You will receive a confirmation email shortly.',
    backToHome: 'Back to Home',
    goToAccount: 'Go to My Account',
    paymentError: 'Payment Error',
    contactSupport: 'Contact Us for Support',
    invalidSession: 'Invalid session',

    // Payment Error
    paymentFailed: 'Payment Failed',
    paymentFailedMessage: 'We\'re sorry, but your payment could not be processed. Please try again or contact us if the problem persists.',
    paymentDetails: 'Payment Details',
    errorDetails: 'Error Details',
    whatToDo: 'What to do:',
    checkCardDetails: 'Check that your card details are correct',
    ensureSufficientFunds: 'Make sure you have sufficient funds',
    tryDifferentCard: 'Try a different payment method',
    contactSupportIfNeeded: 'Contact us if you continue to have problems',
    retryPayment: 'Retry Payment',

    // Insufficient Spots Error
    insufficientSpots: 'Sorry, Too Late!',
    insufficientSpotsMessage: 'We\'re sorry, but there are no more spots available for this trip. Only {availableSpots} spots remain.',
    insufficientSpotsDetails: 'Unfortunately, other travelers have completed their bookings while you were processing the payment. Check our other available trips or contact us for assistance.',

    // Refund
    refund: {
        requestTitle: 'Refund Request',
        requestDescription: 'You can request a refund only for the final payment (balance). The deposit cannot be refunded.',
        trip: 'Trip',
        amount: 'Amount',
        reasonLabel: 'Reason for refund',
        reasonPlaceholder: 'Explain why you are requesting a refund...',
        reasonRequired: 'Provide a reason for the refund request',
        submitRequest: 'Submit Request',
        requestSubmitted: 'Refund request sent successfully. You will receive a confirmation email shortly.',
        requestError: 'Error sending refund request. Please try again.',
        requestStatus: 'Refund request sent and being processed.',
        alreadyRequested: 'Refund already requested',
        requestPending: 'Refund request pending',
        requestApproved: 'Refund request approved',
        requestRejected: 'Refund request rejected',
        requestProcessed: 'Refund request processed',
        refundRequests: 'Refund Requests',
        refundRequestBalance: 'Request balance refund (€{amount})',
        refundRequestSentOn: 'Sent on: {date}',
        refundRequestProcessedOn: 'Processed on: {date}',
        refundRequestNotes: 'Notes: {notes}',
        refundDepositNotAvailable: 'Deposit refund is not available. Only the balance can be refunded.'
    },

    // Resume Payment
    resumeDepositPayment: 'Resume Deposit Payment',
    resumeBalancePayment: 'Pay Final Installment',
    paymentPending: 'Payment In Progress...',
    payDepositFirst: 'Pay deposit first',

    // Account Page
    yourPayments: 'Your Payments',
    totalPaid: 'Total Paid',
    notPaid: 'Not Paid',
    inProgress: 'Pending',
    completed: 'Completed',
    partiallyPaid: 'Partially Paid',
    actions: 'Actions',
    accountActions: 'Account Actions',
    noPaymentsFound: 'No payments found',
    paymentLoadingError: 'Error loading payments',

    // Trip Details Booking Section
    bookThisTrip: 'Book This Trip',
    completeBooking: 'Complete the booking by paying the deposit. The balance must be paid one month before the trip.',
    depositInfo: 'The deposit is 30% of the total price',
    balanceInfo: 'The balance (70%) must be paid one month before the trip',
    importantInfo: {
        title: 'Important Information',
        depositPercent: '• Deposit to be paid at booking',
        balancePercent: '• The balance must be paid one month before the trip',
        stripeSecure: '• Payments are securely handled by Stripe',
        noCardStorage: '• We do not store your credit card data',
        emailConfirmation: '• You will receive a confirmation email after each payment'
    }
};

export default payment;
